module.exports = __webpack_public_path__ + "43fa91cf61f5efe290e904e12bad2a18.svg";